// Murmur assets required by all entrypoints
// Please think twice about adding new imports to this file. We should be aiming
// to eliminate these or extract them into @kaizen/component-library to move
// towards separating our entrypoints into distinct apps.

import './ca-common.styles';

// Expose bugsnag as a global so that our Rails view can access it.
// eslint-disable-next-line import/no-extraneous-dependencies
import 'expose-loader?exposes=bugsnag!@bugsnag/js';

import 'core-js';
import 'regenerator-runtime/runtime';
import 'jquery';
import 'ca-assets/vendor/bootstrap.2.3.1.custom';
import 'ca-assets/vendor/jquery-cookie-v1.1';
import 'jquery_ujs';
import 'ca-assets/vendor/browser-detect';
import 'whatwg-fetch/dist/fetch.umd';
import 'ca-assets/javascripts/common';
import 'focus-visible';
import notifyError from 'ca-error-handler/notifyError';
import setupIntercom from 'ca-intercom';

import './csrf-patch';

import 'ca-assets/images/spinner-16x16-light.gif';
import 'ca-assets/images/background/login__background--ocean.jpg';
import 'ca-assets/images/background/login__background--peach.jpg';
import 'ca-assets/images/background/login__background.svg';
import 'ca-assets/images/background/login__background--wisteria.jpg';
import 'ca-assets/images/generic-business-logo@2x.png';
import 'ca-assets/images/generic-business-logo@1x.png';
import 'ca-assets/images/generic-business-logo-small@2x.png';
import 'ca-assets/images/generic-business-logo-small@1x.png';
import 'ca-assets/images/baseline-survey.png';
import 'ca-assets/images/candidate-survey.png';
import 'ca-assets/images/goals.png';
import 'ca-assets/images/culture-amp-logo-email-footer.png';

setupIntercom().catch((err) => {
  notifyError(err);
});
